module.exports = __webpack_public_path__ + "img/wbicon-zengcheng.7500d6e8.jpg";